import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.57 22.528a1.5 1.5 0 0 0 .43-1.051v-2.825a3.5 3.5 0 0 0 2.816-3.125Q23 13.46 23 11q0-1.982-.12-3.475a3.5 3.5 0 0 0-3.239-3.211Q15.257 3.999 12.032 4 8.8 4 4.36 4.315a3.5 3.5 0 0 0-3.24 3.212Q1 9.02 1 11q0 2.455.184 4.522a3.5 3.5 0 0 0 3.235 3.18 107 107 0 0 0 9.388.266l3.641 3.578a1.5 1.5 0 0 0 2.122-.018m-.106-4.814a.5.5 0 0 0-.464.498v3.265a.5.5 0 0 1-.85.356l-3.792-3.726a.5.5 0 0 0-.36-.143q-.956.018-1.913.018-3.748 0-7.595-.277a2.5 2.5 0 0 1-2.31-2.272A50 50 0 0 1 2 11q0-1.942.116-3.393a2.5 2.5 0 0 1 2.315-2.294Q8.838 5 12.032 5q3.186 0 7.538.311a2.5 2.5 0 0 1 2.313 2.294Q22 9.056 22 11q0 2.415-.18 4.439c-.11 1.22-1.086 2.182-2.356 2.275",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React.createElement("circle", { cx: 20, cy: 4, r: 3.5, stroke: "currentColor" }))
);
var SvgMessageUnreadOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MessageUnreadOutlined_default = SvgMessageUnreadOutlined;

export { MessageUnreadOutlined_default as default };
